import React, { useState, useEffect } from "react"
import Gallery from "react-grid-gallery"
import fileDownload from "js-file-download"

import { IPicture } from "../../interfaces/picture"
import UserPhotoApi from "../../services/api/UserPhoto.api"

const Photos = () => {
  const [currentIndex, setCurrentIndex] = useState<number | null>(null)
  const [photos, setPhotos] = useState<IPicture[]>([])

  useEffect(() => {
    new UserPhotoApi().getMe().then(setPhotos)
  }, [])

  return (
    <div>
      <Gallery
        images={photos.map(p => ({
          src: p.hd,
          thumbnail: p.xs,
          thumbnailHeight: p.thumbnailHeight,
          thumbnailWidth: p.thumbnailWidth
        }))}
        enableImageSelection={false}
        backdropClosesModal
        currentImageWillChange={setCurrentIndex}
        customControls={
          currentIndex !== null
            ? [
                <button
                  className="button is-primary"
                  onClick={async () => {
                    const url = photos[currentIndex].original
                    const response = await fetch(url, {
                      cache: "no-cache"
                    })
                    fileDownload(
                      await response.blob(),
                      `photo_${photos[currentIndex].id}.jpg`
                    )
                  }}
                >
                  Télécharger cette photo
                </button>
              ]
            : []
        }
      />
    </div>
  )
}

export default Photos
